export default {
  baseinfo: {
    dataSource: 'Data source ',
    language: 'Language',
    languageNote: 'Please choose language',
    english: 'English',
    chinese: 'Chinese',
    others: 'Other',
    othersLang: 'Please enter other languages, i.e. French',
    standard: 'Mandarin ',
    yes: 'Yes',
    no: 'No',
    othersStandard: 'Enter non-Mandarin, i.e. Dongbei Dialect',
    content: 'Content type',
    history: 'History ',
    education: 'Education',
    technology: 'Technology',
    otherContent: 'Please enter other scene type',
    scene: 'Scene type',
    sceneType1: 'Quiet',
    sceneType2: 'Telephone',
    sceneType3: 'Interphone',
    oherScene: 'Please enter other scene type',
    frequency: 'Audio sampling rate',
    frequencyNote: 'Please choose',
    depth: 'Sampling depth',
    depthNote: 'Please choose',
    wavRadio: 'Audio channel',
    wavRadio1: 'Single',
    wavRadio2: 'Double',
    format: 'File format',
    formatOther: 'Please enter other file format',
    remarks: 'Notes',
    skillTitle: 'Skills needed by collectors or annotators',
    skill: 'Skills needed',
    qualifiedTitle: 'Data standard',
    qualified: 'Eligibility criteria',
    criterionTitle: 'Validity criteria',
    criterion: 'Judgement standard',
    js: {
      rules: {
        language: 'Please choose language',
        languageOther: 'Please enter other languages',
        standard: 'Please choose Mandarin or not',
        contentTypeOther: 'Please enter other content type',
        format: 'Please choose at least one file format',
        formatOther: 'Please enter file format',
        qualified: 'Please enter eligibility criteria',
        skill: 'Please enter skills needed',
        criterion: 'Please enter validity criteria'
      }
    }
  },
  business: {
    template: 'Set template',
    labelDesign: 'Design label',
    radio: 'Single choice',
    checkbox: 'Multiple choice',
    show1: 'Speech annotation template (quick preview)',
    show2: 'Speech transcription template (quick preview)',
    show3: 'Speech splitting template (quick preview)',
    labelTag: 'Add labels',
    cut: 'Does it need to be cut?',
    cut1: 'Yes',
    cut2: 'No',
    invalid: 'Invalid audio explanation',
    special: 'Special transcription explanation',
    introduce: 'Task introduction',
    brief: 'Brief introduction',
    taskDate: 'Task schedule',
    date: 'Time period',
    startDate: 'Starting time',
    to: 'To',
    endDate: 'Ending time',
    js: {
      rules: {
        brief1: 'Please enter brief introduction',
        brief2: 'The length is limited within 128 characters',
        introduce1: 'Please enter task introduction',
        introduce2: 'The length is limited within 1,024 characters',
        date1: 'Please choose time period'
      },
      title: 'Title',
      label: 'Choice',
      labelContent: 'Choice explanation',
      text: 'Gap filling'
    }
  },
  qcprice: {
    scale: 'Data scale',
    voiceNum: 'Audio amount',
    num: 'Hours',
    hour: '',
    voiceQuality: 'Audio quality',
    voiceQuaNote: 'Please choose',
    taskTime: 'Estimated time',
    minute: 'Minutes (time for annotate one audio)',
    checkType: 'Quality inspection method',
    checkType2: 'Method',
    checkTypeNote: 'Please choose',
    checkProportion1: ' QI price rate',
    checkProportion2: '%（Quality inspection price/Task price）',
    spotCheck1: 'Inspection percent',
    spotCheck2: '%',
    spotCheck3: 'Sample size【',
    spotCheck4: ' H】Inspection unit price【',
    spotCheck5: ' Credits/H】',
    allCheckNum1: 'Inspection frequency',
    allCheckNum2: 'Times',
    allCheckNum3: 'Inspection amount【',
    allCheckNum4: ' H】Inspection unit price【',
    allCheckNum5: ' Credits/Hour】',
    rightAnswer1: 'Golden hit',
    rightAnswer2: '个/条',
    tagNumber1: 'Annotator number',
    tagNumber2: '人/条（每条数据最多多少人做）',
    tagNumber3: 'At least annotate【',
    tagNumber4: ' H】',
    tagNumber5: 'At most annotate【',
    goldTest1: 'Percent',
    goldTest2: 'Estimated annotate【',
    price1: 'Price',
    quotenote: '如果您愿意给到标注员100泛函币作为劳动报酬，泛函将额外收取30泛函币作为平台服务费，您总共需要支付130泛函币。',
    price2: 'Suggested price【',
    price3: 'Lowest price【',
    offer1: 'Annotation unit price',
    offer2: 'Credits/Hour',
    sum1: 'Total price of quality inspection【',
    sum2: 'Credits】',
    sum3: 'Total price【',
    js: {
      rules: {
        num1: 'Please enter audio amount',
        num2: 'Piece must be a number',
        hour1: 'Please enter total time period',
        hour2: 'Total time period must be a number',
        scale1: 'Please enter data size',
        scale2: 'Data size must be a number',
        voiceQuality: 'Please choose audio quality',
        taskTime1: 'Please enter time period ',
        taskTime2: 'Time period must be a number',
        checkType: 'Please choose quality inspection time',
        checkProportion1: 'Please enter',
        checkProportion2: 'Must be a number',
        spotCheck1: 'Please enter quality inspection percent',
        spotCheck2: 'Quality inspection number must be a number',
        allCheckNum1: 'Please enter inspection times',
        allCheckNum2: 'Inspection times must be a number',
        rightAnswer1: 'Please enter',
        rightAnswer2: 'Must be a number',
        tagNumber1: 'Please enter number of annotators',
        tagNumber2: 'Number of annotators must be a number',
        goldTest1: 'Please enter',
        goldTest2: 'Must be a number',
        offer1: 'Please enter unit price ',
        offer2: 'Unit price must be a number'
      }
    }
  },
  sample: {
    name: 'Name',
    describe: 'Description',
    selectExample: 'Sample',
    selectExampleNote: 'Please choose a sample',
    fileName: 'File name',
    fileSize: 'Size',
    scope: 'Operate',
    choiceVoice: 'Upload a new file',
    uploadVoice: 'Click to upload',
    uploadVoiceNote: 'Audio only, at most 20Mb',
    trueExample: 'Correct list of samples',
    falseExample: 'Incorrect list of samples',
    addExample: 'Add a sample',
    true: 'Confirm',
    cancel: 'Cancellation',
    delete: 'Delete',
    exampledata: 'Sample',
    selectexamdata: 'Please choose sample',
    uploadnewfile: 'Upload a new file',
    confirm: 'Confirm',
    reset: 'Cancellation',
    filename: 'Filename',
    filesize: 'Size',
    operate: 'Operate',
    remove: 'Remove',
    lessupload: ' Audio only, at most 20Mb each',
    clickupload: 'Click to upload',
    save: 'Save',
    trueexample: 'Correct list of samples',
    addexample: 'Add a sample',
    errorexample: 'Incorrect list of samples',
    js: {
      rules: {
        name1: 'Please enter name',
        name2: 'The length should from 1 to 10 characters',
        selectExample: 'Please choose sample'
      },
      addStatus: {
        type1: 'Edit answer',
        type2: 'Add an answer'
      },
      success: {
        type1: 'Success',
        type2: 'Confirm',
        type3: 'Delete success',
        type4: 'Upload success',
        type5: 'Add success'
      },
      error: {
        type1: 'Failure',
        type2: 'Warning',
        type3: 'Cancellation',
        type4: 'Picture uploading error, please refresh retry!',
        type5: 'Each user uploads up to 10 files at most!',
        type6: 'The upload size is too large'
      },
      deleteSampleFile: 'After the file is removed, the corresponding sample will be deleted. Do you want to continue?',
      deleteSampleItem: 'You are deleting the sample. Do you want to continue?'
    }
  },
  tutorial: {
    tutorial: 'Guidelines',
    finish: 'Finish'
  }
}



// WEBPACK FOOTER //
// ./src/lang/en/pushWav.js